import { Campaign } from '../services/IAnalyticsService';
import { UtmCampaignName, UtmContent, UtmMedium, UtmTerm } from '../enum/AnalyticsEnum';

export const buildCampaign = (pageName, type): Campaign => {
    return {
        utm_source: type ? `${type}-email` : 'email',
        utm_medium: UtmMedium.DEFAULT,
        utm_campaign_name: UtmCampaignName[pageName],
        utm_term: UtmTerm[pageName],
        utm_content: UtmContent[pageName]
    }
}
